module.exports = __webpack_public_path__ + "img/kaduna.29b1043b.png";